import TrainingWizardStepOne, { validator } from './TrainingWizardStepOne'

export { validator }
export default TrainingWizardStepOne
